import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import classNames from 'classnames'
import React from 'react'
import { i18n } from '../../domain/index'
import css from './pagination.css'
type Props = {
  total: number
  page: number
  pageSize: number
  pageSizeOptions?: Array<number>
  onPageChange: (...args: Array<any>) => any
  onPageSizeChange: (...args: Array<any>) => any
  hideLegend?: boolean
}
const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200]

const getPages = (page: number, pageSize: number, total: number, linkCount = 5) => {
  const pages: number[] = []
  const pageCount = Math.ceil(total / pageSize)
  const half = (linkCount - 1) / 2
  let start = page - half
  const end = page + half

  if (start < 1) {
    start = 1
  } else if (end > pageCount) {
    start -= end - pageCount

    if (start < 1) {
      start = 1
    }
  }

  for (let i = start; pages.length < linkCount && i <= pageCount; ++i) {
    pages.push(i)
  }

  return pages
}

const getPrevPage = (page) => {
  return Math.max(page - 1, 1)
}

const getNextPage = (page, pageSize, total) => {
  const pageCount = Math.ceil(total / pageSize)
  return Math.min(page + 1, pageCount)
}

const Pagination = (props: Props) => {
  const pageSizeOptions = props.pageSizeOptions || PAGE_SIZE_OPTIONS
  const hideLegend = !!props.hideLegend
  const pageMin = props.pageSize * props.page - (props.pageSize - 1)
  const pageMax = Math.min(props.pageSize * props.page, props.total)
  return (
    <div
      className={classNames(css.component, {
        [css.hideLegend]: hideLegend,
      })}
    >
      <div className={css.legend}>
        {pageMin}-{pageMax} / {props.total}
      </div>
      <div className={css.pageSizeOptions}>
        <ul>
          <li className={css.pageSizeOptionsLabel}>
            <span>{i18n.t('pagination.pageSizeOptionsLabel')}</span>
          </li>
          {pageSizeOptions.map((option, i) => (
            <li
              className={classNames(css.pageSizeOption, {
                [css.active]: option === props.pageSize,
              })}
              key={i}
            >
              <a onClick={() => props.onPageSizeChange(option)}>{option}</a>
            </li>
          ))}
        </ul>
      </div>
      <div className={css.pages}>
        <ul>
          <li className={css.pagesPrev}>
            <a onClick={() => props.onPageChange(getPrevPage(props.page))}>
              <ArrowLeftIcon />
            </a>
          </li>
          {getPages(props.page, props.pageSize, props.total).map((page, i) => (
            <li
              className={classNames(css.page, {
                [css.active]: page === props.page,
              })}
              key={i}
            >
              <a onClick={() => props.onPageChange(page)}>{page}</a>
            </li>
          ))}
          <li className={css.pagesNext}>
            <a onClick={() => props.onPageChange(getNextPage(props.page, props.pageSize, props.total))}>
              <ArrowRightIcon />
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Pagination
